export const today = new Date().toISOString().slice(0, 10);
let date = new Date(new Date());
export const aMonthAgo = date.toISOString().slice(0, 10);
